import React, { useContext, useState } from 'react';
import { UserContext } from '../../../App';
import OrderHeader from '../../Order/OrderHeader/OrderHeader';

const AddService = () => {
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const [file, setFile] = useState(null)
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    const [success, setSuccess] = useState('')
    const handleInfo = (e) => {
        setInfo({...info, [e.target.name] : e.target.value})
    }
    const handleChange = (e) => {
        const newFile = e.target.files[0]
        setFile(newFile)
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData()
        console.log(info);
        formData.append('file', file);
        formData.append('title', info.title);
        formData.append('description', info.description);
        formData.append('price', info.price);
        fetch('https://assignment-11-samiun.herokuapp.com/addService', {
            method: "POST",
            body: formData
        })
        .then(res => res.json())
        .then(data => {
            if(data){
                setSuccess('Service added successfully')
            }
        })
    }
    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader />
            </div>
            <div className="col-md-10 mt-4 p-4" style={{height: '100vh', background: 'whitesmoke'}}>
                <div style={{background: 'white', borderRadius: '10px'}} className="p-5 container">
                <form onSubmit={handleSubmit}>
                    <div className="d-flex ">
                    <div style={{marginRight: '30px'}}>
                        <div className="mb-3">
                        <label className="form-label">Service Title</label>
                        <input type="text" className="form-control" required name="title" onBlur={handleInfo}/>
                        </div>
                        <div className="mb-3">
                        <label className="form-label">Description</label>
                        <input type="text" className="form-control" required style={{width: '400px'}} name="description" onBlur={handleInfo}/>
                        </div>
                    </div>
                    <div>
                        <div className="mb-3">
                        <label className="form-label">Service Price</label>
                        <input type="number" className="form-control" required name="price" onBlur={handleInfo}/>
                        </div>
                        <div className="mb-3">
                        <label className="form-label">Image</label>
                        <br/>
                        <input type="file" required className="upload-btn" name="img" onChange={handleChange}/>
                        </div>
                    </div>
                    </div>
                    <button type="submit" className="btn btn-success" >Submit</button>
                    {success && <div className="alert alert-success mt-3">{success}</div>}
                </form>
                </div>
            </div>
        </div>
    );
};

export default AddService;